module.exports = __webpack_public_path__ + "img/scipher-request-demo.7a16ddbe.png";